import { useEffect, useState } from 'react'

// Re-renders on an interval so time-based checks (e.g. stale status) update without new data.
export default function useNow(intervalMs: number, skip = false) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (skip) return

    const interval = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(interval)
  }, [intervalMs, skip])

  return now
}
